import { render, staticRenderFns } from "./ModelIncome.vue?vue&type=template&id=34ed0b2d&scoped=true&"
import script from "./ModelIncome.vue?vue&type=script&lang=js&"
export * from "./ModelIncome.vue?vue&type=script&lang=js&"
import style0 from "./ModelIncome.vue?vue&type=style&index=0&id=34ed0b2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ed0b2d",
  null
  
)

export default component.exports